export default __webpack_public_path__ + "static/media/uploadTask.4c3b9ed5.svg";